module.exports = __webpack_public_path__ + "static/img/s2.3438e2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/s2.png
// module id = hFlk
// module chunks = 1